import { createAction } from '@reduxjs/toolkit';
import { IOrder } from '../../../../dto';
import { ACT_SET, TYPE_LIST, MN_ORDERS } from '../../../../common';

export const setOrders = createAction<IOrder[]>(
  `${MN_ORDERS}/${TYPE_LIST}/${ACT_SET}`,
);
